export default __webpack_public_path__ + "static/media/CTF 2.bc744e14.png";